import {useTranslation} from "react-i18next";

export const EmptyValue = () => {
  const {t} = useTranslation();
  return <em>{t("control-card.value.empty")}</em>;
};
